<div class="gax-label">{{ label }}</div>
<div class="options">
  <ng-content selector="gax-option"></ng-content>
</div>
